<template>
    <div class="information-card-template" :class="[getCardBackgroundColorClass()]">
        <div class="information-card-content" v-if="chart_selected.html !== '' || chart_selected.title">
            <div class="d-flex align-items-center mb-3" v-if="chart_selected.icon || chart_selected.title">
                <div v-if="chart_selected.icon" class="information-card-icon me-3" :class="getIconColorClass()">
                    <img v-if="isImageUrl(chart_selected.icon)" :src="chart_selected.icon" class="icon" alt="Card icon">
                    <img v-else :src="chart_selected.icon" class="icon" alt="Card icon">
                </div>
                <h3 v-if="chart_selected.title" class="information-card-title mb-0">{{ chart_selected.title }}</h3>
            </div>
            <div v-if="chart_selected.html" v-html="displayHtml" />
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'InformationCardTemplate',
    props: {
        chart_selected: {
            type: Object,
            required: true
        }
    },
    computed: {
        displayHtml() {
            if (!this.chart_selected.html) return '';
            const decoded = decodeURIComponent(this.chart_selected.html);
            return this.fixListTags(decoded);
        }
    },
    methods: {
        /**
         * Quill v2 outputs both bullet and ordered lists as <ol> with data-list on <li>.
         * Convert <ol> to <ul> when list items have data-list="bullet" so bullets render correctly.
         */
        fixListTags(htmlString) {
            if (!htmlString || !htmlString.trim()) return htmlString;
            const doc = new DOMParser().parseFromString(htmlString, 'text/html');
            const ols = doc.querySelectorAll('ol');
            ols.forEach((ol) => {
                const firstLi = ol.querySelector(':scope > li');
                if (firstLi && firstLi.getAttribute('data-list') === 'bullet') {
                    const ul = doc.createElement('ul');
                    while (ol.firstChild) {
                        ul.appendChild(ol.firstChild);
                    }
                    ol.parentNode.replaceChild(ul, ol);
                }
            });
            return doc.body.innerHTML;
        },
        isImageUrl(url) {
            if (!url) return false;
            return url.startsWith('http');
        },
        getIconColorClass() {
            if (!this.chart_selected.icon_background_color || this.isImageUrl(this.chart_selected.icon)) {
                return '';
            }
            return `icon-${this.chart_selected.icon_background_color}`;
        },
        getCardBackgroundColorClass() {
            if (!this.chart_selected.if_card_white) {
                return '';
            }
            return `card-white`;
        }
    }
});
</script>